import { ICONS } from './icons';

export type ParkingKeypadType = {
  type: 'number' | 'backspace' | 'search';
  label: string;
  iconPath?: string;
};

export const PARKING_KEYPADS: ParkingKeypadType[] = [
  {
    label: '1',
    type: 'number',
  },
  {
    label: '2',
    type: 'number',
  },
  {
    label: '3',
    type: 'number',
  },
  {
    label: '4',
    type: 'number',
  },
  {
    label: '5',
    type: 'number',
  },
  {
    label: '6',
    type: 'number',
  },
  {
    label: '7',
    type: 'number',
  },
  {
    label: '8',
    type: 'number',
  },
  {
    label: '9',
    type: 'number',
  },
  {
    label: '<-',
    iconPath: ICONS.PARKING_KEYPAD_BACKSPACE,
    type: 'backspace',
  },
  {
    label: '0',
    type: 'number',
  },
  {
    label: '검색',
    type: 'search',
  },
];

type FeeTableRow = {
  title: string;
  descriptions: string[];
  notes: string[];
};

export const FEE_TABLE_ROWS: FeeTableRow[] = [
  {
    title: 'parking.feeTable.freeTime.title',
    descriptions: ['parking.feeTable.freeTime.info1'],
    notes: ['parking.feeTable.freeTime.info2'],
  },
  {
    title: 'parking.feeTable.hourlyParking.title',
    descriptions: ['parking.feeTable.hourlyParking.info1'],
    notes: ['parking.feeTable.hourlyParking.info2'],
  },
  // {
  //   title: 'parking.feeTable.monthlyParking.title',
  //   descriptions: ['parking.feeTable.monthlyParking.info1-1', 'parking.feeTable.monthlyParking.info1-2'],
  //   notes: ['parking.feeTable.monthlyParking.info2'],
  // },
  // {
  //   title: 'parking.feeTable.constructionVehicles.title',
  //   descriptions: ['parking.feeTable.constructionVehicles.info1'],
  //   notes: ['parking.feeTable.constructionVehicles.info2-1', 'parking.feeTable.constructionVehicles.info2-2'],
  // },
];

type FreeFeeTableRow = {
  purchase: number;
  hour: number;
};
export const FREE_FEE_TABLE_ROWS: FreeFeeTableRow[] = [
  {
    purchase: 2,
    hour: 1,
  },
  {
    purchase: 3,
    hour: 2,
  },
  {
    purchase: 5,
    hour: 3,
  },
  {
    purchase: 10,
    hour: 5,
  },
];
